import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { dispatchEventBus } from '@/util';
@Component({})
export default class PageViewHeaderWithActionBar extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: String }) title!: string
    @Prop({ type: Boolean, default: false }) eventBus!: boolean

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    back() {
        if (this.eventBus) {
            dispatchEventBus(window, 'header-back', null)
        } else {
            history.back()
        }
    }
}